import $axios from '@/axios-instance.js'

// Encuestas de satisfacción de las charlas. El admin arma plantillas (las
// preguntas) y una encuesta por charla; el asistente responde desde la sala.
export default class SurveysService {
  adminUrl = '/api/v1/admin/surveys'
  templatesUrl = '/api/v1/admin/survey-templates'
  eventUrl = '/api/v1/event/surveys'

  // ====== Admin: encuestas ======
  index(params) {
    return $axios.get(this.adminUrl, params)
  }

  show(id) {
    return $axios.get(`${this.adminUrl}/${id}`)
  }

  store(params) {
    return $axios.post(this.adminUrl, params)
  }

  update(id, params) {
    return $axios.post(`${this.adminUrl}/${id}`, { ...params, _method: 'PUT' })
  }

  destroy(id) {
    return $axios.post(`${this.adminUrl}/${id}`, { _method: 'DELETE' })
  }

  // silent: activa sin abrirle el popup a nadie (la lista y el contador del
  // asistente se actualizan igual).
  activate(id, silent = false) {
    return $axios.post(`${this.adminUrl}/${id}/activate`, { silent })
  }

  close(id) {
    return $axios.post(`${this.adminUrl}/${id}/close`)
  }

  // Varias a la vez (action: activate | close | show | hide): un solo aviso a
  // los asistentes.
  bulk(registryId, ids, action, silent = false) {
    return $axios.post(`${this.adminUrl}/bulk`, {
      registry_id: registryId,
      ids,
      action,
      silent,
    })
  }

  report(id) {
    return $axios.get(`${this.adminUrl}/${id}/report`)
  }

  export(id) {
    return $axios.get(`${this.adminUrl}/${id}/export`, { responseType: 'blob' })
  }

  // ====== Admin: plantillas ======
  templates(params) {
    return $axios.get(this.templatesUrl, params)
  }

  showTemplate(id) {
    return $axios.get(`${this.templatesUrl}/${id}`)
  }

  storeTemplate(params) {
    return $axios.post(this.templatesUrl, params)
  }

  updateTemplate(id, params) {
    return $axios.post(`${this.templatesUrl}/${id}`, { ...params, _method: 'PUT' })
  }

  destroyTemplate(id) {
    return $axios.post(`${this.templatesUrl}/${id}`, { _method: 'DELETE' })
  }

  duplicateTemplate(id) {
    return $axios.post(`${this.templatesUrl}/${id}/duplicate`)
  }

  // ====== Asistente ======
  list() {
    return $axios.get(this.eventUrl)
  }

  // Con tope de tiempo: un servidor saturado que no contesta cuenta como un
  // fallo más y entra en los reintentos, en vez de dejar el botón girando.
  respond(uuid, answers) {
    return $axios.post(
      `${this.eventUrl}/${uuid}/responses`,
      { answers },
      { timeout: 15000 },
    )
  }
}
export const SurveysServiceInstance = new SurveysService()
